import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="py-12 px-6 md:px-12 bg-navy border-t border-white/10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <span className="font-display text-xl text-white">
              Cali<span className="italic-teal">Moms</span> Connect
            </span>
            <p className="text-white/60 text-sm mt-2 flex flex-col sm:flex-row items-center sm:items-baseline gap-1 sm:gap-3">
              <span>
                Questions? Reach out to{' '}
                <a 
                  href="mailto:hello@calimomsconnect.com" 
                  className="text-seafoam hover:text-white underline"
                >
                  hello@calimomsconnect.com
                </a>
              </span>
              <span className="hidden sm:inline text-white/30">|</span>
              <a
                href="https://www.instagram.com/calimomsconnect"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-white/60 hover:text-seafoam transition-colors"
                data-testid="footer-instagram-link"
              >
                <Instagram size={14} />
                @calimomsconnect
              </a>
            </p>
          </div>
          
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/privacy" 
              className="text-white/60 hover:text-seafoam transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className="text-white/60 hover:text-seafoam transition-colors"
              data-testid="footer-terms-link"
            >
              Terms of Service
            </Link>
          </div>
        </div>
        
        <p className="text-white/50 text-sm mt-8 text-center">
          © {new Date().getFullYear()} Cali Moms Connect. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
